import { render, staticRenderFns } from "./AirportEdit.vue?vue&type=template&id=8a966b6a&"
import script from "./AirportEdit.vue?vue&type=script&lang=js&"
export * from "./AirportEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports